import React from 'react';
import useFilterModalContext from '../../useFilterModalContext';
import useSearchParams from '../../../../useSearchParams';
import {XMarkIcon, ArrowRightIcon} from '@heroicons/react/20/solid';

export default () => {
  const {setFilterType} = useFilterModalContext();
  const {query, setQuery} = useSearchParams();

  if (!query.trackedAtFrom && !query.trackedAtTo) {
    return null;
  }

  return (
    <div className="pb-4 border-b border-c-border flex flex-col gap-2">
      <div className="flex items-center gap-1">
        <h4 className="m-0 font-bold">最新Webサイト訪問期間</h4>
        <button
          onClick={() => setFilterType('trackedAt')}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <ArrowRightIcon className="w-3 h-3 text-c-light" />
        </button>
        <button
          onClick={() =>
            setQuery({
              ...query,
              trackedAtFrom: '',
              trackedAtTo: '',
            })
          }
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <XMarkIcon className="w-3 h-3 text-c-light" />
        </button>
      </div>
      <div>
        {query.trackedAtFrom && (
          <span className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
            {query.trackedAtFrom}
          </span>
        )}
        <span className="text-c-light px-2">~</span>
        {query.trackedAtTo && (
          <span className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
            {query.trackedAtTo}
          </span>
        )}
      </div>
    </div>
  );
};
